import {Component} from 'react';
import {Button, Form, Header} from 'semantic-ui-react';
import PropTypes from 'prop-types';
import './AdminNotesFilter.scss';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';


export default class AdminNotesFilter extends Component {

  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
    showCountry: PropTypes.bool,
  };

  constructor(props) {
    super(props);
    this.state = {
      username: '',
      createdAfter: moment().subtract(3, 'day').toDate(),
      createdBefore: '',
      franchiseId: '',
      franchiseName: '',
      country: '',
    };
  }

  onChange = (field) => (e, {value}) => {
    this.setState({[field]: value});
  };

  onDateChange = (field) => (date) => {
    this.setState({[field]: date});
  };

  onSubmit = () => {
    const {onSubmit} = this.props;
    const {username, createdAfter, createdBefore, franchiseId, franchiseName, country} = this.state;

    onSubmit({
      username: username || null,
      createdAfter: createdAfter || null,
      createdBefore: createdBefore || null,
      franchiseId: franchiseId || null,
      franchiseName: franchiseName || null,
      country: country || null,
    });
  };

  render() {
    const {
      username,
      createdAfter,
      createdBefore,
      franchiseId,
      franchiseName,
      country,
    } = this.state;

    return (
      <Form className="notes-filter" onSubmit={this.onSubmit}>
        <Header>Filter</Header>
        <Form.Input id="username" inline onChange={this.onChange('username')} value={username} className="username" label="Username"/>
        {this.props.showCountry && <Form.Input inline onChange={this.onChange('country')} value={country} className="country" label="Country"/>}
        <Form.Field
          id="created-after" inline className="created-after" label="Created After"
          control={() => (<DatePicker
            selected={createdAfter}
            onChange={this.onDateChange('createdAfter')}
            showTimeSelect
            timeFormat="HH:mm"
            timeIntervals={60}
            dateFormat="MMM dd, yyyy"
            timeCaption="time"
          />)}
        />
        <Form.Field
          id="created-before" inline className="created-before" label="Created Before"
          control={() => (<DatePicker
            selected={createdBefore}
            onChange={this.onDateChange('createdBefore')}
            showTimeSelect
            timeFormat="HH:mm"
            timeIntervals={60}
            dateFormat="MMM dd, yyyy"
            timeCaption="time"
          />)}
        />
        <Form.Input id="franchise-id" inline onChange={this.onChange('franchiseId')} value={franchiseId} className="franchise-id" label="Franchise Id"/>
        <Form.Input id="franchise-name" inline onChange={this.onChange('franchiseName')} value={franchiseName} className="franchise-name" label="Franchise Name"/>
        <Button onClick={this.onSubmit}>Search</Button>
      </Form>
    );
  }
}